import React from "react";
import CenteredColumnLayout from "./CenteredColumnLayout";
import RowColLayout from "./RowColLayout";

const LandingCard = ({ imagen, text, backColor, backColor2 = "white", ancho }) => {

    const alturaTextSec = text ? "20%" : "0%";
    const alturaImg = text ? "80%" : "100%";

    return (
        <div className="landingCard m-0 p-0 d-flex justify-content-center align-items-center" style={{ backgroundColor: backColor2, height: "100%", width: "100%", borderRadius: "18px", }}>


            <div className="landingCardInner m-0 p-0" style={{backgroundColor: backColor, borderRadius: "18px", height: "95%", width: "95%", boxShadow: "0 5px 9px rgba(0, 0, 0, 0.28)" }}>

                <div className="row d-flex justify-content-center align-items-center m-0 p-0" style={{height: alturaImg, backgroundColor: "transparent"}}>
                    <div className="col-12 d-flex justify-content-center align-items-center m-0 p-0">
                        <img src={imagen} alt="" style={{height: "auto", width: ancho, maxHeight: "100px"}} />
                    </div>
                </div>

                {text && (
                <div className="row m-0 p-0" style={{height: alturaTextSec}}>
                    <div className="col-12 m-0 p-0">
                        <p className="ms-2 my-0 text-white">{text}</p>
                    </div>
                </div>
                )}
            </div>

        </div>
    );
};

export default LandingCard;
